import { ManualFindingFlagReason } from '../constants/comment';

export function getFlagReasonTranslationKey(reason: ManualFindingFlagReason): string {
  return `flag_reason_${reason}`;
}
